import React, { useEffect, useState } from 'react';
import { purchaseNotifications } from '../mock';
import { CheckCircle2, X } from 'lucide-react';

export default function LiveNotifier() {
  const [idx, setIdx] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let cycle;
    let transitionTimer;
    const startTimer = setTimeout(() => {
      setVisible(true);
      cycle = setInterval(() => {
        setVisible(false);
        transitionTimer = setTimeout(() => {
          setIdx((i) => (i + 1) % purchaseNotifications.length);
          setVisible(true);
        }, 400);
      }, 8000);
    }, 10000);

    return () => {
      clearTimeout(startTimer);
      clearTimeout(transitionTimer);
      clearInterval(cycle);
    };
  }, []);

  const n = purchaseNotifications[idx];

  return (
    <div
      className={`fixed bottom-6 left-6 z-40 transition-all duration-500 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
      }`}
    >
      <div className="flex items-center gap-3 bg-white rounded-xl shadow-2xl border border-slate-200 pl-3 pr-6 py-3 min-w-[240px]">
        <div className="w-9 h-9 rounded-full bg-emerald-500 flex items-center justify-center flex-shrink-0">
          <CheckCircle2 className="text-white" size={20} />
        </div>
        <div className="flex-1">
          <div className="text-sm font-bold text-slate-900">{n.name} from {n.city}</div>
          <div className="text-xs text-slate-600">purchased {n.plan}</div>
          <div className="text-xs text-slate-400">{n.time}</div>
        </div>
        <button onClick={() => setVisible(false)} className="absolute top-1 right-1 text-slate-400 hover:text-slate-600">
          <X size={12} />
        </button>
      </div>
    </div>
  );
}
